/**
 * Stripe Connect onboarding hand-off (H §6.3): tmm-api returns an https Stripe URL, opened in the
 * SAME tab — but only after checking the scheme and host. Unlike a bootstrapped URL (0028's
 * `assignBootstrappedUrl`, which allows `http://localhost` for local runs), an onboarding link
 * must be `https:` on `stripe.com` or a subdomain thereof, with no exception.
 */

export function isStripeOnboardingUrl(value: string | undefined): value is string {
  if (!value) return false;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:') return false;
    return url.hostname === 'stripe.com' || url.hostname.endsWith('.stripe.com');
  } catch {
    return false;
  }
}

/** Same-tab navigation, a seam so tests can observe it (jsdom's `location.assign` is not spy-able). */
export function navigateTo(url: string): void {
  window.location.assign(url);
}
